import { Flex, IconButton } from "@chakra-ui/react";
import { IconArrowRight } from "components/icons/Icons";
import { ActionCellProps } from "../types";

export function ActionCell({ 
  orderId, 
  includeExpeditedTurnaround, 
  orderStatusId, 
  onShowProjectDetails 
}: ActionCellProps) {
  return (
    <Flex align="center" width={"40px"} mr="0">
      <IconButton
        aria-label="search"
        bg="inherit"
        borderRadius="inherit"
        onClick={(e) => {
          onShowProjectDetails(orderId);
        }}
        _active={{
          bg: "inherit",
          transform: "none",
          borderColor: "transparent",
        }}
        _hover={{
          bg: "inherit",
        }}
        _focus={{
          boxShadow: "none",
        }}
        icon={<IconArrowRight w="49px" h="50px" />}
      />
    </Flex>
  );
}
